import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./components/pages/Dashboard";
import Users from "./components/pages/Users";
import NewUser from "./components/pages/NewUser";
import NewProduct from "./components/pages/NewProduct";
import ViewProducts from "./components/pages/ViewProducts";
import ViewCategories from "./components/pages/ViewCategories";
import NewCategory from "./components/pages/NewCategory";
import ViewSubCategories from "./components/pages/ViewSubCategories";
import NewSubCategory from "./components/pages/NewSubCategory";
import ViewVendors from "./components/pages/ViewVendors";
import NewVendor from "./components/pages/NewVendor";

function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Dashboard />} />
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/users" element={<Users />} />
          <Route exact path="/new-user" element={<NewUser />} />
          <Route exact path="/view-products" element={<ViewProducts />} />
          <Route exact path="/new-product" element={<NewProduct/>} />
          <Route exact path="/view-categories" element={<ViewCategories/>} />
          <Route exact path="/new-category" element={<NewCategory/>} />
          <Route exact path="/view-sub-categories" element={<ViewSubCategories/>} />
          <Route exact path="/new-sub-category" element={<NewSubCategory/>} />
          <Route exact path="/view-vendors" element={<ViewVendors/>} />
          <Route exact path="/new-vendor" element={<NewVendor/>} />
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
